import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

// Copy is governed by docs/A2P_SMS_COMPLIANCE.md §3 — update the doc first.
const TermsOfService = () => {
  return (
    <div className="container mx-auto p-10 sm:p-20 max-w-3xl">
      <Helmet>
        <title>Terms of Service — Build Construx, Inc</title>
      </Helmet>

      <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
      <p className="text-sm text-gray-500 mb-8">
        Build Construx, Inc &middot; Effective Date: July 29, 2026
      </p>

      <p className="mb-6">
        Build Construx, Inc. designs and manufactures digitally fabricated building systems that
        help streamline residential construction. Through innovative off-site manufacturing and
        precision-engineered building components, we provide solutions that improve construction
        efficiency, quality, and speed for builders, developers, and homeowners. By opting into the
        Build Construx SMS messaging program, you agree to the following terms and conditions:
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3">1. Types of Messages</h2>
      <p className="mb-3">You may receive text messages related to:</p>
      <ul className="list-disc pl-6 mb-4 space-y-1">
        <li>Appointment confirmations and reminders</li>
        <li>Project scheduling updates</li>
        <li>Installation status updates</li>
        <li>Estimate follow-ups and invoice notifications</li>
        <li>Promotional offers and new product announcements</li>
        <li>Free estimate announcements and company updates</li>
      </ul>

      <h2 className="text-xl font-bold mt-8 mb-3">2. Message Frequency</h2>
      <p className="mb-4">
        Message frequency varies. You may receive up to 4&ndash;6 messages per month depending on
        active projects and promotions.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3">3. Opt-Out Instructions</h2>
      <p className="mb-4">
        You can cancel the SMS service at any time. Just text <strong>"STOP"</strong> to{' '}
        <strong>+1 737-201-9423</strong>. After you send the SMS message "STOP" to us, we will send
        you a confirmation message that you have been unsubscribed. After this, you will no longer
        receive SMS messages from us.
      </p>
      <p className="mb-4">
        If you want to join again, simply sign up as you did the first time and we will resume
        messaging.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3">4. Help Instructions</h2>
      <p className="mb-4">
        If you are experiencing issues with the messaging program, you can reply with the keyword{' '}
        <strong>HELP</strong> for assistance, or contact us directly at:
      </p>
      <address className="not-italic mb-4">
        <strong>Build Construx, Inc.</strong>
        <br />
        Email:{' '}
        <a href="mailto:hello@buildconstrux.com" className="underline">
          hello@buildconstrux.com
        </a>
        <br />
        Website:{' '}
        <a href="https://buildconstrux.com" className="underline">
          buildconstrux.com
        </a>
      </address>

      <h2 className="text-xl font-bold mt-8 mb-3">5. Carrier Disclaimer</h2>
      <p className="mb-4">Carriers are not liable for delayed or undelivered messages.</p>

      <h2 className="text-xl font-bold mt-8 mb-3">6. Message &amp; Data Rates</h2>
      <p className="mb-4">
        Message and data rates may apply for any messages sent to you from us and to us from you.
        If you have questions about your text or data plan, please contact your wireless provider.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3">7. Privacy</h2>
      <p className="mb-8">
        If you have questions regarding privacy, please review our Privacy Policy at:{' '}
        <Link to="/privacy" className="underline">
          https://www.buildconstrux.com/privacy
        </Link>
        .
      </p>
    </div>
  );
};

export default TermsOfService;
